import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0050',
    ecrans: ['00-2']
});
